import { AD_GROUP, LDAP_GROUP, REQUEST_TYPE } from 'pages/myidm/utils/constant';
import { validateGroupName } from 'pages/myidm/utils/validation';

export const resetCostEstimateDetails = {
    details: [],
    totalOneTimeCost: {
        item: 'Total One Time',
        frequency: 'One Time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'yearly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'The License cost for safe in myPAM per user per year is $350 and cost is not estimated in DevX Infra for existing user with safe details.',
};
export const resetOrder = {
    adGroup: null,
    businessApplication: null,
    businessApplicationDetails: null,
    environment: null,
    envShortName: null,
    sector: null,
    typeOfRequest: null,
    AppShortName: null,
    applicationName: null,
    adGroupType: null,
    adGroupTypeDetails: null,
    groupOwner: null,
    groupOwnerDetails: null,
    appService: null,
    members: null,
    mypamsafeDetails: [],
    nonSafeDetailsGpid: [],
    estimatedCost: resetCostEstimateDetails,
    isTouched: false,
};

export const getSelectMemberBtnStatus = ({ order }) => {
    if (!order?.groupType) {
        return { isValid: false, message: 'Group Type is required' };
    }
    // Check if it's not a new AD group and all adGroups and members are filled for existing groups
    if (order?.typeOfRequest === REQUEST_TYPE.MODIFY && order?.groupType === AD_GROUP) {
        if (!Array.isArray(order?.multipleAdGroups) || order.multipleAdGroups.length === 0) {
            return { isValid: false, message: 'At least one AD Group must be added for existing groups.' };
        }
        const missingAdGroupIndex = order.multipleAdGroups.findIndex((group) => !group?.adGroup);
        if (missingAdGroupIndex !== -1) {
            return { isValid: false, message: `AD Group must be selected for all existing groups (missing at index ${missingAdGroupIndex + 1}).` };
        }
        const missingMembersIndex = order.multipleAdGroups.findIndex((group) => !Array.isArray(group?.members) || group?.members?.length === 0);
        if (missingMembersIndex !== -1) {
            return { isValid: false, message: `At least one member must be added for AD Group at index ${missingMembersIndex + 1}.` };
        }
    }
    // Check if it's not a new AD group and ADGroup is not selected
    if (order?.typeOfRequest === REQUEST_TYPE.MODIFY && !order?.adGroup && order?.groupType === LDAP_GROUP) {
        return { isValid: false, message: 'LDAP Group must be selected for existing groups.' };
    }

    // If it's a new AD group, ensure all relevant fields are filled for AD group
    if (order?.typeOfRequest === REQUEST_TYPE.NEW && order?.groupType === AD_GROUP) {
        if (!order?.appShortName) return { isValid: false, message: 'App short name is required for new AD groups.' };
        if (!order?.groupOwner) return { isValid: false, message: 'Group owner is required for new AD groups.' };
        if (!order?.adGroupType) return { isValid: false, message: 'AD Group type is required for new AD groups.' };
        if (!order?.applicationName) return { isValid: false, message: 'Application name is required for new AD groups.' };
        if (!order?.appService) return { isValid: false, message: 'Application service is required for new AD groups.' };
    }

    // If it's a new LDAP group, ensure relevant fields are filled for LDAP group
    if (order?.typeOfRequest === REQUEST_TYPE.NEW && order?.groupType === LDAP_GROUP) {
        if (!order?.projectName || !/^[A-Za-z0-9]{2,10}$/.test(order?.projectName)) {
            return { isValid: false, message: 'Project name is required for new LDAP groups.' };
        }
        if (!order?.groupOwner) return { isValid: false, message: 'Group owner is required for new LDAP groups.' };
        if (!order?.appService) return { isValid: false, message: 'Application service is required for new LDAP groups.' };
    }

    // Check for general fields that must be filled for any group type
    if (!order?.businessApplication) return { isValid: false, message: 'Business application is required.' };
    if (!order?.environment) return { isValid: false, message: 'Environment is required.' };
    if (!order?.sector) return { isValid: false, message: 'Sector is required.' };

    // If all checks pass, return true
    return { isValid: true, message: 'All fields are valid.' };
};

export const isReadyToGetCost = ({ order, appShortNameValid, appShortNameExist, applicationNameValid }) => {
    // Check for existing AD group fields
    if (order?.typeOfRequest === REQUEST_TYPE.MODIFY) {
        if (!order?.adGroup || !order?.adGroupType) {
            return { isValid: false, message: 'AdGroup or AdGroupType is required for existing AD group' };
        }
    }

    // Check for new AD group fields
    if (order?.typeOfRequest === REQUEST_TYPE.NEW) {
        const missingFields = [];
        if (!order?.appShortName) missingFields.push('appShortName');
        if (!order?.groupOwner) missingFields.push('groupOwner');
        if (!order?.adGroupType) missingFields.push('adGroupType');
        if (!order?.applicationName) missingFields.push('applicationName');
        if (!appShortNameValid || appShortNameExist) missingFields.push('Invalid or existing appShortName');
        if (!applicationNameValid || !order?.appService) missingFields.push('Invalid application name or missing appService');
        if (order?.groupType === LDAP_GROUP && (!applicationNameValid || !order?.appService))
            missingFields.push('Invalid application name or missing appService');

        if (missingFields.length > 0) {
            return { isValid: false, message: `Missing required fields for new AD group: ${missingFields.join(', ')}` };
        }
    }

    // Check common fields (applicable to both new and existing AD groups)
    if (!order?.businessApplication) {
        return { isValid: false, message: 'Business application is required' };
    }
    if (!order?.environment) {
        return { isValid: false, message: 'Environment is required' };
    }
    if (!order?.sector) {
        return { isValid: false, message: 'Sector is required' };
    }
    if (!order?.members?.length > 0) {
        return { isValid: false, message: 'At least one member is required' };
    }

    // Check for Privileged AD group specific field
    if (order?.adGroupType === 'Privileged' && !order?.nonSafeDetailsGpid?.length > 0) {
        return { isValid: false, message: 'nonSafeDetailsGpid is required for Privileged AdGroupType' };
    }

    // If all checks pass
    return { isValid: true, message: 'Order is ready to get cost' };
};
export const isReadyToSubmitForAdGroupNewMembership = ({ order }) => {
    // Check for required common fields
    if (!order?.businessApplication) {
        return { isValid: false, message: 'Business application is required.' };
    }
    if (!order?.environment) {
        return { isValid: false, message: 'Environment is required.' };
    }
    if (!order?.sector) {
        return { isValid: false, message: 'Sector is required.' };
    }
    if (!order?.appOwnerDetails || !order?.appOwnerDetails?.gpid) {
        return { isValid: false, message: 'Application Owner is required.' };
    }
    if (!order?.groupType) {
        return { isValid: false, message: 'Group Type is required.' };
    }

    // Check if multipleResourceGroups exists and has at least one group
    if (!Array.isArray(order?.multipleResourceGroups) || order?.multipleResourceGroups?.length === 0) {
        return { isValid: false, message: 'At least one resource group must be added.' };
    }

    // Helper to compute the read-only prefix from group fields
    const getGroupNamePrefix = (grp) => {
        const category = grp?.groupCategory || '';
        const subCategoryBackendName = grp?.groupSubCategoryDetails?.backendName || '';
        const cloudType = grp?.cloudType || '';
        if (!category || !subCategoryBackendName || !cloudType) return '';
        return `${category}.${subCategoryBackendName}.${cloudType}.`;
    };

    // Validate each resource group
    const invalidGroupIndex = order?.multipleResourceGroups?.findIndex((group, idx) => {
        if (!group?.groupName) {
            return true;
        }
        const grpPrefix = getGroupNamePrefix(group);
        if (!validateGroupName(group.groupName, grpPrefix, order?.multipleResourceGroups, idx).isValid) {
            return true;
        }
        if (!group?.groupCategory) {
            return true;
        }
        if (!group?.groupSubCategoryDetails || !group?.groupSubCategoryDetails?.label) {
            return true;
        }
        if (!group?.domainType) {
            return true;
        }
        if (!group?.activeDirectoryGroupType) {
            return true;
        }
        if (!group?.groupOwnerDetails || !group?.groupOwnerDetails?.gpid) {
            return true;
        }
        if (!Array.isArray(group?.members) || group?.members?.length === 0) {
            return true;
        }
        if (group?.members?.some((member) => !member?.gpid)) {
            return true;
        }
        return false;
    });

    if (invalidGroupIndex !== -1) {
        const group = order?.multipleResourceGroups[invalidGroupIndex];
        if (!group?.groupName) {
            return { isValid: false, message: `Group name is required for resource group at index ${invalidGroupIndex + 1}.` };
        }
        const grpPrefix = getGroupNamePrefix(group);
        const groupNameValidation = validateGroupName(group.groupName, grpPrefix, order?.multipleResourceGroups, invalidGroupIndex);
        if (!groupNameValidation.isValid) {
            return { isValid: false, message: groupNameValidation.message };
        }
        if (!group?.groupCategory) {
            return { isValid: false, message: `Group category is required for resource group at index ${invalidGroupIndex + 1}.` };
        }
        if (!group?.groupSubCategoryDetails || !group?.groupSubCategoryDetails?.label) {
            return { isValid: false, message: `Group sub category is required for resource group at index ${invalidGroupIndex + 1}.` };
        }
        if (!group?.domainType) {
            return { isValid: false, message: `Domain type is required for resource group at index ${invalidGroupIndex + 1}.` };
        }
        if (!group?.activeDirectoryGroupType) {
            return { isValid: false, message: `Active Directory Group type is required for resource group at index ${invalidGroupIndex + 1}.` };
        }
        if (!group?.groupOwnerDetails || !group?.groupOwnerDetails?.gpid) {
            return { isValid: false, message: `Group owner is required for resource group at index ${invalidGroupIndex + 1}.` };
        }
        if (!Array.isArray(group?.members) || group?.members?.length === 0) {
            return { isValid: false, message: `At least one member must be added for resource group at index ${invalidGroupIndex + 1}.` };
        }
        const invalidMemberIndex = group?.members?.findIndex((member) => !member?.gpid);
        if (invalidMemberIndex !== -1) {
            return { isValid: false, message: `Member at index ${invalidMemberIndex + 1} in resource group ${invalidGroupIndex + 1} must have a valid GPID.` };
        }
    }

    // If all checks pass, return true
    return { isValid: true, message: 'Order is ready to submit for AD Group New Membership.' };
};
export const isReadyToSubmitForGroupOwnerChange = ({ order }) => {
    // Check Group Type
    if (!order?.groupType) {
        return { isValid: false, message: 'Group Type is required.' };
    }

    // Check Application section fields
    if (!order?.sector) {
        return { isValid: false, message: 'Sector is required.' };
    }
    if (!order?.environment) {
        return { isValid: false, message: 'Environment is required.' };
    }
    if (!order?.businessApplication) {
        return { isValid: false, message: 'Business Application is required.' };
    }
    if (!order?.appOwnerDetails || !order?.appOwnerDetails?.gpid) {
        return { isValid: false, message: 'Application Owner is required.' };
    }

    // Check AD Group selection (the group whose owner will be changed)
    if (!order?.adGroup) {
        return { isValid: false, message: 'AD Group is required for group owner change.' };
    }

    // Check new Group Owner selection
    if (!order?.groupOwner) {
        return { isValid: false, message: 'New Group Owner is required.' };
    }
    if (!order?.groupOwnerDetails || !order?.groupOwnerDetails?.gpid) {
        return { isValid: false, message: 'Group Owner details are required.' };
    }

    // Validate that the new group owner is different from the current one
    // Compare using the label/display value since adGroupOwner contains the display string
    if (order?.adGroupOwner && order?.groupOwner) {
        // Extract GPID from the current owner if it's in "GPID - Name" format
        const currentOwnerGpid = order?.adGroupOwner?.includes(' - ') ? order.adGroupOwner.split(' - ')[0].trim() : order?.adGroupOwner;
        const newOwnerGpid = order?.groupOwnerDetails?.gpid;

        if (currentOwnerGpid === newOwnerGpid) {
            return { isValid: false, message: 'New Group Owner must be different from the current Group Owner.' };
        }
    }

    return { isValid: true, message: 'Order is ready to submit for AD Group Owner Change.' };
};
export const isReadyToSubmitForRemoveMember = ({ order }) => {
    if (!order?.groupType) {
        return { isValid: false, message: 'Group Type is required' };
    }
    if (!order?.domainType) {
        return { isValid: false, message: 'Domain Type is required' };
    }
    if (order?.adGroupMembers?.length > 0) {
        return { isValid: true, message: 'At least one member is selected for removal.' };
    }
    return { isValid: false, message: 'No members selected for removal.' };
};
export const isReadyToSubmitForDisableGroup = ({ order }) => {
    if (!order?.businessApplication) {
        return { isValid: false, message: 'Business Application is required' };
    }
    if (!order?.environment) {
        return { isValid: false, message: 'Environment is required' };
    }
    if (!order?.sector) {
        return { isValid: false, message: 'Sector is required' };
    }
    if (!order?.appOwnerDetails) {
        return { isValid: false, message: 'Application Owner is required' };
    }
    // if (!order?.groupType) {
    //     return { isValid: false, message: 'Group Type is required' };
    // }
    // Check if at least one AD group is added for disable
    if (order?.adGroupListForDisable?.length > 0) {
        // Check if confirmation checkbox is checked
        if (order?.disableConfirmationChecked) {
            return { isValid: true, message: 'Ready to submit disable request.' };
        }
        return { isValid: false, message: 'Please confirm you understand the impact of disabling these groups.' };
    }
    return { isValid: false, message: 'At least one AD Group must be added for disable.' };
};

export const isReadyToSubmit = ({ order, appShortNameValid, appShortNameExist, applicationNameValid }) => {
    if (!order?.groupType) {
        return { isValid: false, message: 'Group Type is required' };
    }
    // Check if it's not a new AD group and all adGroups and members are filled for existing groups
    if (order?.typeOfRequest === REQUEST_TYPE.MODIFY && order?.groupType === AD_GROUP) {
        if (!Array.isArray(order?.multipleAdGroups) || order.multipleAdGroups.length === 0) {
            return { isValid: false, message: 'At least one AD Group must be added for existing groups.' };
        }
        const missingAdGroupIndex = order.multipleAdGroups.findIndex((group) => !group?.adGroup);
        if (missingAdGroupIndex !== -1) {
            return { isValid: false, message: `AD Group must be selected for all existing groups (missing at index ${missingAdGroupIndex + 1}).` };
        }
        const missingMembersIndex = order.multipleAdGroups.findIndex((group) => !Array.isArray(group?.members) || group?.members?.length === 0);
        if (missingMembersIndex !== -1) {
            return { isValid: false, message: `At least one member must be added for AD Group at index ${missingMembersIndex + 1}.` };
        }
    }
    if (order?.typeOfRequest === REQUEST_TYPE.MODIFY && !order?.adGroup && order?.groupType === LDAP_GROUP) {
        return { isValid: false, message: 'LDAP Group must be selected for existing groups.' };
    }

    // If it's a new AD group, ensure all relevant fields are filled for AD group
    if (order?.typeOfRequest === REQUEST_TYPE.NEW && order?.groupType === AD_GROUP) {
        if (!order?.appShortName) return { isValid: false, message: 'App short name is required for new AD groups.' };
        if (!appShortNameValid || appShortNameExist) return { isValid: false, message: 'Invalid or existing appShortName.' };
        if (!order?.groupOwner) return { isValid: false, message: 'Group owner is required for new AD groups.' };
        if (!order?.adGroupType) return { isValid: false, message: 'AD Group type is required for new AD groups.' };
        if (!order?.applicationName) return { isValid: false, message: 'Application name is required for new AD groups.' };
        if (!applicationNameValid || !order?.appService) return { isValid: false, message: 'Application service is required for new AD groups.' };
        if (!applicationNameValid) return { isValid: false, message: 'Application Valid Name is required for new AD groups.' };
    }

    // If it's a new LDAP group, ensure relevant fields are filled for LDAP group
    if (order?.typeOfRequest === REQUEST_TYPE.NEW && order?.groupType === LDAP_GROUP) {
        if (!order?.projectName || !/^[A-Za-z0-9]{2,10}$/.test(order?.projectName)) {
            return { isValid: false, message: 'Project name is required for new LDAP groups.' };
        }
        if (!order?.groupOwner) return { isValid: false, message: 'Group owner is required for new LDAP groups.' };
        if (!order?.appService) {
            return { isValid: false, message: 'Application service is required for new LDAP groups.' };
        }
    }

    // Check for general fields that must be filled for any group type
    if (!order?.businessApplication) return { isValid: false, message: 'Business application is required.' };
    if (!order?.environment) return { isValid: false, message: 'Environment is required.' };
    if (!order?.sector) return { isValid: false, message: 'Sector is required.' };
    if (!order?.appOwnerDetails) return { isValid: false, message: 'Application Owner is required.' };

    // If all checks pass, return true
    return { isValid: true, message: 'All fields are valid.' };
};
